export function isFunction(value) {
  return typeof value === 'function'
}

export function runIfFn(value, ...args) {
  return isFunction(value) ? value(...args) : value
}

export function callAllHandlers(...fns) {
  return function func(event) {
    fns.some(fn => {
      fn?.(event)
      return event?.defaultPrevented
    })
  }
}
